export const dateToMonthAndYear = (date, month = 'short', year = 'numeric') =>
  `${new Date(date).toLocaleString('en-US', {
    timeZone: 'UTC',
    month,
    year,
  })}`;
